import {useEffect} from 'react';
import {useMatches} from 'react-router';
import {emitPageView} from '@di-shared/features/analytics/index';

export interface AnalyticPageViewProps {
  screenName?: string;
}

function AnalyticPageView({screenName}: AnalyticPageViewProps) {
  const matches = useMatches();

  useEffect(() => {
    const lastMatch = matches[matches.length - 1];
    // HOME은 QS(tab) 기반으로 탭별 GA를 구분하므로 HomeContents에서 직접 처리함.
    // routes/index.tsx → App → AnalyticPageView 순환참조를 피하기 위해 ROUTE_PATHS 대신 리터럴 사용.
    if (lastMatch.id === 'HOME') {
      return;
    }
    emitPageView(screenName || lastMatch.id);
  }, [matches, screenName]);
  return null;
}

export default AnalyticPageView;
